import { Lightbulb, X } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { XStack, YStack } from "tamagui";
import { PlanTemplateType } from "../../templates/generated/template_types";
import { getStringInLS, saveStringInLS } from "../core/localStorage";
import Blinking from "../ui/Blinking";
import { Body } from "../ui/Body";
import { Label } from "../ui/Label";
import type PlanModel from "./PlanModel";

export const DidYouKnowBanner = observer(({ plan }: { plan: PlanModel }) => {
  const [show, setShow] = React.useState(false);

  const LS_BANNER_KEY = `did_you_know-${plan.uid}`;

  React.useEffect(() => {
    // Only show for custom templates
    if (plan.data.template === PlanTemplateType.CustomTemplate) {
      setShow(getStringInLS(LS_BANNER_KEY) === undefined);
    }
  }, [plan, LS_BANNER_KEY]);

  const hideBanner = React.useCallback(() => {
    setShow(false);
    saveStringInLS(LS_BANNER_KEY, "1");
  }, [LS_BANNER_KEY]);

  if (!show) {
    return null;
  }

  return (
    <XStack
      gap="$medium"
      justifyContent="space-between"
      alignItems="center"
      width={"100%"}
      padding="$large"
      backgroundColor={"$backgroundMutedBlock"}
    >
      <XStack flex={1} gap="$medium" alignItems="center">
        <Blinking>
          <Lightbulb color="#000" size={"$medium"} />
        </Blinking>
        <YStack flex={1} gap={"$small"}>
          <Label>Did you know this about Planira?</Label>
          <XStack gap="$medium">
            <Body muted>It's free to use for any event.</Body>
          </XStack>
        </YStack>
      </XStack>

      <Body
        flexShrink={0}
        cursor="pointer"
        onPress={() => {
          hideBanner();
        }}
      >
        <X color={"$muted"} />
      </Body>
    </XStack>
  );
});
